import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { PrimaryContactModal } from './component/primary-applicant/primary-form/primary.model';
import { AddressDetailModal } from './component/primary-applicant/address-detail/address-detail.model';
import { EnvDataService } from '../../app/services/env-data-service';
import { SdfFormService } from '../../app/services/sdf-form-service';
import { DataService } from './services/data.service';
import { PrimaryForm } from './component/primary-applicant/primary-form/primary';

import { DependentDetails } from './component/dependent-and-family/dependent-details/dependent-details';
import { EmploymentDetails } from './component/employment-and-incomedetails/employment-details/employment_details';
import { IncomeDetails } from './component/employment-and-incomedetails/income-details/income_details';
import { ContactFormService } from './services/contact-form.service';
import { AddressDetail } from './component/primary-applicant/address-detail/address-detail';
import { ContactList } from '../contact-list/contact_list';
import { LoadingProvider } from '../../providers/loading/loading';
import { ShowContactForm } from '../show-contact/show-contact';
declare var google;

@Component({
  selector: 'editcontactfromlist',
  templateUrl: 'edit-contact-from-list.html',
  providers: [EnvDataService, DataService, ContactFormService]
})
export class EditContactList {
  @ViewChild(DependentDetails) DependentDetails: DependentDetails;
  @ViewChild(EmploymentDetails) EmploymentDetails: EmploymentDetails;
  @ViewChild(IncomeDetails) IncomeDetails: IncomeDetails;
  @ViewChild(PrimaryForm) PrimaryForm: PrimaryForm;
  @ViewChild(AddressDetail) AddressDetail: AddressDetail;


  SDF_form_document_id: any;
  primary_uid: any;
  userRole: any;
  deleted_access: any;
  primary_Contact_load = false;
  additional_Contact_load = false;
  public primaryformget: any;
  public addressformget: any;
  public dependentformget: any;
  public employmentformget: any;
  public incomeformget: any;
  public primaryContact: any;
  public additionalContact: any;

  primary_form:FormGroup;
  address_detail_form:FormGroup;
  dependent_detail_form:FormGroup;
  employment_detail_form:FormGroup;
  income_detail_form:FormGroup;

  step1FormStatus:boolean = false;
  step2FormStatus:boolean = false;
  step3FormStatus:boolean = false;
  step4FormStatus:boolean = false;
  step5FormStatus:boolean = false;
  step6FormStatus:boolean = false;

  //public AddressDetail: AddressDetailModal = new AddressDetailModal();

  public itemList =
    [
      { name: '1 Primary Applicant Details' },
      { name: '2 Dependents and Family' },
      { name: '3 Your Employment and Income Details' },
      { name: '4 Assets and Liabilities' },
      { name: '5 Real Estate Assets' },
    ];

  primaryApplicantDetails: boolean = true;
  primaryApplicantDetailsIcon = 'close-circle';
  dependentAndFamily: boolean = true;
  dependentAndFamilyIcon = 'close-circle';
  employmentAndIncomeDetails: boolean = true;
  employmentAndIncomeDetailsIcon = 'close-circle';
  assetsAndLiablities: boolean = false;
  assetsAndLiablitiesIcon = 'close-circle';
  realEstate: boolean = false;
  realEstateIcon = 'close-circle';
  public indexx: number;
  public secondary_uid: any;




  constructor(
    public db: AngularFirestore,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private ContactFormService: ContactFormService,
    private DataService: DataService,
    public SdfFormService: SdfFormService,
    public app: App,
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public navCtrl: NavController,
  ) {
    debugger;
    this.secondary_uid = [];
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    //thiss.loadingProvider.startLoading();
    this.ContactFormService.getApplicantDetails(window.localStorage.getItem("editUserId")).then((data) => {
      console.log('edit contact from list', data);
      this.primaryContact = data;
      this.primary_Contact_load = true;
      //thiss.loadingProvider.stopLoading();
    });

    // var first = document.getElementById("primaryApplicantDetails");
    // first.style.display = "block";
    // var second = document.getElementById("dependentAndFamily");
    // second.style.display = "none";
    // var third = document.getElementById("employmentAndIncomeDetails");
    // third.style.display = "none";
    //this.primaryApplicantDetailsIcon = 'checkmark';
    //this.ngOnInit()

  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  ngOnInit() {
    var first = document.getElementById("primaryApplicantDetails");
    first.style.display = "block";
    var second = document.getElementById("dependentAndFamily");
    second.style.display = "none";
    var third = document.getElementById("employmentAndIncomeDetails");
    third.style.display = "none";
    this.primaryApplicantDetailsIcon = 'checkmark';

    // this.ADFFormService.getApplicantDetails(window.localStorage.getItem("editUserId")).then((data) => {
    //   console.log('edit contact from list', data);
    //   this.primaryContact=data;
    //   this.primary_Contact_load=true;
    // });
    // let user_id = 'er4gr4sQWaM2KmnqRpOL';
    // let status = 1;
    // this.ContactFormService.updateUserStatus(user_id,status).then((data)=>{
    //   console.log(data);
    // })
  }

  // ngOnDestroy() {
  //   console.log('Items destroyed');
  // }

  submit() {
    this.DependentDetails.addAnotherApplicant();
    this.EmploymentDetails.addAnotherApplicant();
  }

  slideNum(event) {
    if (event == 'first') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "block";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";

      this.primaryApplicantDetailsIcon = 'checkmark';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'close-circle';
    } else if (event == 'second') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "block";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";

      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'checkmark';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'close-circle';
    } else if (event == 'third') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "block";

      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'checkmark';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'close-circle';
    } else if (event == 'forth') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";

      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'checkmark';
      this.realEstateIcon = 'close-circle';
    } else if (event == 'fifth') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";

      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'checkmark';
    }
  }

  stepOne() {
    this.secondfromprevious()
  }
  stepTwo() {
    if(this.PrimaryForm.primaryForm.valid && this.AddressDetail.addreDetail.valid)
        {
          this.firstfromnext()
        }

  }
  stepThree() {
    console.log(this.DependentDetails.slideTwoForm);
    if(this.PrimaryForm.primaryForm.valid && this.AddressDetail.addreDetail.valid && this.DependentDetails.slideTwoForm.valid)
    {
      this.PrimaryForm.getValueSecond('thired');
    }

    //12-04-2021
    //this.thirdfromnext()
  }

  firstfromnext() {

    //debugger;


    //12-04-2021

    let address_data = this.AddressDetail.addreDetail.value;
    console.log(this.PrimaryForm.primaryForm);
    this.primary_form = this.PrimaryForm.primaryForm;
    this.address_detail_form = this.AddressDetail.addreDetail;
     this.markFormGroupTouched(this.primary_form);
     this.markFormGroupTouched(this.address_detail_form);
      console.log(this.AddressDetail.addreDetail);
      if(this.PrimaryForm.primaryForm.valid && this.AddressDetail.addreDetail.valid)
        {
          this.PrimaryForm.getValue();
          this.AddressDetail.getValue();
        }

  }
  secondfromprevious() {



    var first = document.getElementById("primaryApplicantDetails");
    first.style.display = "block";
    var second = document.getElementById("dependentAndFamily");
    second.style.display = "none";
    var third = document.getElementById("employmentAndIncomeDetails");
    third.style.display = "none";

    this.primaryApplicantDetailsIcon = 'checkmark';
    this.dependentAndFamilyIcon = 'close-circle';
    this.employmentAndIncomeDetailsIcon = 'close-circle';
    this.assetsAndLiablitiesIcon = 'close-circle';
    this.realEstateIcon = 'close-circle';
  }

  secondfromnext() {

      //12-04-2021
    let address_data = this.AddressDetail.addreDetail.value;
    console.log(this.PrimaryForm.primaryForm);
    this.primary_form = this.PrimaryForm.primaryForm;
    this.address_detail_form = this.AddressDetail.addreDetail;
    this.dependent_detail_form = this.DependentDetails.slideTwoForm;
     this.markFormGroupTouched(this.primary_form);
     this.markFormGroupTouched(this.address_detail_form);
     this.markFormGroupTouched(this.dependent_detail_form);
      console.log(this.DependentDetails.slideTwoForm);
      if(this.PrimaryForm.primaryForm.valid && this.AddressDetail.addreDetail.valid && this.dependent_detail_form.valid)
        {
          var first = document.getElementById("primaryApplicantDetails");
          first.style.display = "none";
          var second = document.getElementById("dependentAndFamily");
          second.style.display = "none";
          var third = document.getElementById("employmentAndIncomeDetails");
          third.style.display = "block";

          this.primaryApplicantDetailsIcon = 'close-circle';
          this.dependentAndFamilyIcon = 'close-circle';
          this.employmentAndIncomeDetailsIcon = 'checkmark';
          this.assetsAndLiablitiesIcon = 'close-circle';
          this.realEstateIcon = 'close-circle';
          this.DependentDetails.getValue();
        }

    // var first = document.getElementById("primaryApplicantDetails");
    // first.style.display = "none";
    // var second = document.getElementById("dependentAndFamily");
    // second.style.display = "none";
    // var third = document.getElementById("employmentAndIncomeDetails");
    // third.style.display = "block";

    // this.primaryApplicantDetailsIcon = 'close-circle';
    // this.dependentAndFamilyIcon = 'close-circle';
    // this.employmentAndIncomeDetailsIcon = 'checkmark';
    // this.assetsAndLiablitiesIcon = 'close-circle';
    // this.realEstateIcon = 'close-circle';
    // this.DependentDetails.getValue();
  }

  thirdfromprevious() {
    var first = document.getElementById("primaryApplicantDetails");
    first.style.display = "none";
    var second = document.getElementById("dependentAndFamily");
    second.style.display = "block";
    var third = document.getElementById("employmentAndIncomeDetails");
    third.style.display = "none";

    this.primaryApplicantDetailsIcon = 'close-circle';
    this.dependentAndFamilyIcon = 'checkmark';
    this.employmentAndIncomeDetailsIcon = 'close-circle';
    this.assetsAndLiablitiesIcon = 'close-circle';
    this.realEstateIcon = 'close-circle';
  }

  thirdfromnext() {
    debugger;
    // this.EmploymentDetails.getValue();
    // this.IncomeDetails.getValue();

    //12-04-2021

    let address_data = this.AddressDetail.addreDetail.value;
    console.log(this.PrimaryForm.primaryForm);
    this.primary_form = this.PrimaryForm.primaryForm;
    this.address_detail_form = this.AddressDetail.addreDetail;
    this.dependent_detail_form = this.DependentDetails.slideTwoForm;
    this.employment_detail_form = this.EmploymentDetails.slideThreeForm;
    this.income_detail_form = this.IncomeDetails.incomeForm;
     this.markFormGroupTouched(this.primary_form);
     this.markFormGroupTouched(this.address_detail_form);
     this.markFormGroupTouched(this.dependent_detail_form);
     this.markFormGroupTouched(this.employment_detail_form);
     this.markFormGroupTouched(this.income_detail_form);

      console.log(this.employment_detail_form);
      console.log(this.income_detail_form);
      console.log(this.dependent_detail_form);
      console.log(this.address_detail_form);
      console.log(this.primary_form);

      if(this.PrimaryForm.primaryForm.valid && this.AddressDetail.addreDetail.valid && this.dependent_detail_form.valid && this.employment_detail_form.valid && this.income_detail_form.valid)
        {
          this.EmploymentDetails.getValue();
          this.IncomeDetails.getValue();
        }
  }



  // assign all data value to primary applicant details

  editPrimaryApplicantDetails(userdata) {
    //console.log(userdata);
    this.primaryContact = userdata;
    //   let contact = this.primaryContact;
    //   let primaryGoal = this.primaryGoal;
    //   let AddressDetail = this.AddressDetail;

    //   let primarydata = userdata.primary_applicant.primary_applicant.primary_data;
    //   let primarydetails = userdata.primary_applicant.primary_applicant.primary_details;

    //  // asign primary contact data

    //  var mobile_phone = primarydata.mobile_phone;
    //  mobile_phone = mobile_phone.split(" ").join("");
    //  let firstFour = mobile_phone.slice(0, 4);
    //  let number = mobile_phone.slice(4, 10);
    //  number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
    //  contact.firstname = primarydata.firstname;
    //  contact.middlename = primarydata.middlename;
    //  contact.lastname = primarydata.lastname;
    //  contact.email = primarydata.email;
    //  contact.mobile = number;
    //   console.log(contact);
  }

  primarydetails(count) {
    if (count != true) {
      this.primaryformget = count;
      this.primaryformget.password = this.primaryContact.user_data.password;
      console.log('primarydetails', count);
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "block";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";

      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'checkmark';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'close-circle';
    }

  }

  primarydetailsSecond(count) {
    if (count != true) {
      this.primaryformget = count;
      this.primaryformget.password = this.primaryContact.user_data.password;
      console.log('primarydetails', count);
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "block";

      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'checkmark';
    }

  }

  displayCounter(count) {
    this.addressformget = count;
    console.log('count', count);
  }

  dependentdetails(count) {
    this.dependentformget = count;
    console.log('dependentdetails', count);
  }

  employmentdetails(count) {
    debugger;
    this.employmentformget = count;

    console.log('employmentdetails', count);

    this.IncomeDetails.getRoleStartDate(count);
  }
  addincome(event) {
    debugger;

    if(this.IncomeDetails) {
      this.IncomeDetails.addeventIncome(event);
    }
    // if(event=="yes"){
    //   this.income_detail_form = this.IncomeDetails.incomeForm;
    //   this.IncomeDetails.incomeForm.controls[0]['controls'].sallary_payslip_0.setValidators(Validators.required);
    // }

  }

  incomedetails(count) {
    this.loadingProvider.startLoading();
    this.incomeformget = count;
    this.primaryformget = this.PrimaryForm.primaryForm.value;
    this.addressformget = this.AddressDetail.addreDetail.value;
    this.dependentformget = this.DependentDetails.slideTwoForm.value;
    this.incomeformget = this.IncomeDetails.incomeForm.value;
    this.employmentformget = this.EmploymentDetails.slideThreeForm.value;
    // this.AddressDetail.getValue();
    // this.DependentDetails.getValue();
    // this.EmploymentDetails.getValue();
    // this.IncomeDetails.getValue();
    // console.log(this.addressformget);
    // console.log(this.primaryContact);
    console.log(this.incomeformget);
    debugger;
    console.log('incomedetails', count);
    console.log('Alldetails', Object.assign(this.primaryformget, this.addressformget, this.dependentformget, this.employmentformget, this.incomeformget));
    var applicant_object = Object.assign(this.primaryformget, this.addressformget, this.dependentformget, this.employmentformget, this.incomeformget);
    var user_id = window.localStorage.getItem("editUserId");
    this.ContactFormService.update_applicant_details(applicant_object, user_id).then((data: any) => {
      console.log('edit contact from list', data);
      if (data.status == "success") {
        var nav = this.app.getRootNav();
        this.presentToast("Successfully updated");
        this.loadingProvider.stopLoading();
        //nav.setRoot(ContactList);
        let contact_uid = window.localStorage.getItem("editUserId");

        this.navCtrl.pop();
        // var nav = this.app.getRootNav();
        // nav.setRoot(ShowContactForm);
        this.navCtrl.push(ShowContactForm,{
          'contact_uid':contact_uid
        });
      }
    })
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.updateValueAndValidity();
      control.markAsDirty();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  checkvalidslide(){

    console.log('within check validation');
    console.log(this.EmploymentDetails.slideThreeForm.valid);
    console.log(this.EmploymentDetails.slideThreeForm);
    if(this.PrimaryForm.primaryForm.valid && this.AddressDetail.addreDetail.valid)
    {
      this.step1FormStatus = true;
      this.primaryApplicantDetailsIcon = 'checkmark';

    }
    else {
      this.step1FormStatus = false;
      this.primaryApplicantDetailsIcon = 'close-circle';
    }


    if(this.DependentDetails.slideTwoForm.valid)
    {
      this.step2FormStatus = true;
      this.dependentAndFamilyIcon = 'checkmark';

    }
    else {
      this.step2FormStatus = false;
      this.dependentAndFamilyIcon = 'close-circle';
    }
    if(this.EmploymentDetails.slideThreeForm.valid)
    {
      this.step3FormStatus = true;
      this.employmentAndIncomeDetailsIcon = 'checkmark';

    }
    else {
      this.step3FormStatus = false;
      this.employmentAndIncomeDetailsIcon = 'close-circle';
    }
    if(
      this.PrimaryForm.primaryForm.valid
      && this.AddressDetail.addreDetail.valid
      && this.DependentDetails.slideTwoForm.valid
      && this.EmploymentDetails.slideThreeForm.valid
      && this.IncomeDetails.incomeForm.valid
      )
    {
      this.step4FormStatus = true;
      //this.incomeDetailsIcon = 'checkmark';

    }
    else {
      this.step4FormStatus = false;
      //this.incomeDetailsIcon = 'close-circle';
    }
    if(
      this.PrimaryForm.primaryForm.valid
     // && this.PrimaryGoal.primaryGoal.valid
      && this.AddressDetail.addreDetail.valid
      && this.DependentDetails.slideTwoForm.valid
      && this.EmploymentDetails.slideThreeForm.valid
      && this.IncomeDetails.incomeForm.valid
      //&& this.AssetsForm.assetsForm.valid
      //&& this.LiablitiesForm.liabilitiesForm.valid
      )
    {
      this.step5FormStatus = true;
      this.assetsAndLiablitiesIcon = 'checkmark';

    }
    else {
      this.step5FormStatus = false;
      this.assetsAndLiablitiesIcon = 'close-circle';
    }
    if(
      this.PrimaryForm.primaryForm.valid
     // && this.PrimaryGoal.primaryGoal.valid
      && this.AddressDetail.addreDetail.valid
      && this.DependentDetails.slideTwoForm.valid
      && this.EmploymentDetails.slideThreeForm.valid
      && this.IncomeDetails.incomeForm.valid
      //&& this.AssetsForm.assetsForm.valid
      //&& this.LiablitiesForm.liabilitiesForm.valid
      //&& this.RealEstateAssets.realEstateForm.valid
      )
    {
      this.step6FormStatus = true;
      this.realEstateIcon = 'checkmark';

    }
    else {
      this.step6FormStatus = false;
      this.realEstateIcon = 'close-circle';
    }

  }

}




// WEBPACK FOOTER //
// ./src/pages/edit-contact-form-list/edit-contact-from-list.ts